import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { ProdutoRendaFixaModel } from "../model/produto-rendafixa.model";

@Injectable()
export class ProdutoRendaFixaService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Ação de Relacionamento por id
     * @param id ID da Ação de Relacionamento
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "rendafixa/produto-renda-fixa/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Ação de Relacionamento
     * @param id ID da Ação de Relacionamento
     */
    getAll(params: Record<string, unknown>): Observable<ApiPaginationResponseDataNonNullable<ProdutoRendaFixaModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<ProdutoRendaFixaModel>>(
            this.utilitesService.urlPrefix + "rendafixa/produto-renda-fixa" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista
     * @param id ID
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "rendafixa/produto-renda-fixa/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Ação de Relacionamento
     * @param id ID da Ação de Relacionamento
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "rendafixa/produto-renda-fixa/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Ação de Relacionamento
     * @param params Json Ação de Relacionamento
     */
    create(params: any): Observable<any> {
        return this._http.post(
            this.utilitesService.urlPrefix + "rendafixa/produto-renda-fixa",
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Atualiza Ação de Relacionamento
     * @param params Json Ação de Relacionamento
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "rendafixa/produto-renda-fixa/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
    /**
     * Atualiza Ação de Relacionamento
     * @param params Json Ação de Relacionamento
     */
    ativeOrInative(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "rendafixa/produto-renda-fixa/active-or-inative/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
